import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import PortalLayout from './components/portal/PortalLayout';
import Inicio from './pages/Inicio';
import Catalogo from './pages/Catalogo';
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import MiCuenta from './pages/MiCuenta';
import Resumen from './pages/portal/Resumen';
import HistorialCompras from './pages/portal/HistorialCompras';
import HistorialRecargas from './pages/portal/HistorialRecargas';
import MenuDiario from './pages/portal/MenuDiario';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Restricciones from './pages/portal/Restricciones';
import { Loader2 } from 'lucide-react';
import Footer from './components/Footer';
import SessionTimeoutModal from './components/SessionTimeoutModal';

// --- Ruta privada para usuarios autenticados ---
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="animate-spin text-orange-500" size={48} />
      </div>
    );
  }

  return user ? children : <Navigate to="/cuenta" replace />;
};

// --- Layout público con Navbar y Footer ---
const PublicLayout = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    <Navbar />
    <main className="flex-grow pt-16">
      <Outlet />
    </main>
    <Footer />
  </div>
);

// --- Componente principal de la App ---
function App() {
  const { loading: authLoading, isIdle, resetIdleTimer, logout } = useAuth();

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="animate-spin text-orange-500" size={48} />
      </div>
    );
  }

  return (
    <>
      <SessionTimeoutModal
        isOpen={isIdle}
        onStay={resetIdleTimer}
        onLogout={logout}
      />
      <Routes>
        {/* --- Rutas públicas --- */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Inicio />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto />} />
        </Route>

        {/* --- Rutas de login y recuperación --- */}
        <Route path="/cuenta" element={<MiCuenta />} />
        <Route path="/actualizar-contrasena" element={<ResetPasswordPage />} />

        {/* --- Rutas privadas del portal --- */}
        <Route
          path="/portal"
          element={
            <PrivateRoute>
              <PortalLayout />
            </PrivateRoute>
          }
        >
          {/* Redirección inicial absoluta */}
          <Route index element={<Navigate to="/portal/resumen" replace />} />

          {/* Rutas internas del portal */}
          <Route path="resumen" element={<Resumen />} />
          <Route path="compras" element={<HistorialCompras />} />
          <Route path="recargas" element={<HistorialRecargas />} />
          <Route path="menu" element={<MenuDiario />} />
          <Route path="restricciones" element={<Restricciones />} />

          {/* Catch-all absoluto para portal */}
          <Route path="*" element={<Navigate to="/portal/resumen" replace />} />
        </Route>

        {/* Catch-all global */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
